import React from "react";
import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import { ImageAsset, SVGAsset } from "res";

import "./styles.css";

/**
 * @function AddToWalletPage
 * @return {React.Component}
 * @exported true
 * @description The main component for AddToWalletPage
 */
export default function AddToWalletPage(props) {
  return (
    <MainContentContainer className="add-to-wallet-page" header={<MainContentHeader text="Add to Wallet" />}>
      <div className="framed-icon-container">
        <SVGAsset id="PhoneSignalIcon" />
      </div>
      <div className="flex-container flex-horizontal align-center-container content-container">
        <div className="flex-width text-center">
          <p>Add your card and shop online, in store and in apps, where your digital wallet is accepted. Choose a digital wallet to add your card too.</p>
        </div>
      </div>
      <div className="flex-container flex-horizontal align-center-container content-container ui-icon-button-container">
        <div className="flex-width text-right">
          <DisabledPrompt>
            <button className="flex-container flex-horizontal align-center-container icon-button apple-wallet-button">
              <div className="set-width">
                <ImageAsset id="AppleWalletIcon" />
              </div>
              <div className="flex-width">
                <p className="text-left add-to-text">Add to</p>
                <p className="text-left">Apple Wallet</p>
              </div>
            </button>
          </DisabledPrompt>
        </div>
        <div className="flex-width text-left">
          <DisabledPrompt>
            <button className="flex-container flex-horizontal align-center-container icon-button google-wallet-button">
              <div className="set-width">
                <ImageAsset id="GoogleWalletAsset" />
              </div>
              <div className="flex-width">
                <p className="text-left add-to-text">Add to</p>
                <p className="text-left">Google Wallet</p>
              </div>
            </button>
          </DisabledPrompt>
        </div>
      </div>
    </MainContentContainer>
  );
}